import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";


/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default{

    props: ['show', 'user', 'addCredits'],

    data() {
        return {
            locale: LocService,
            title: '',
            isLoading: false,
            addCreditsValue: false,
            selectedUser: null,
            hasError: '',
            amount: 0,
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedUser = this.user;
                this.addCreditsValue = this.addCredits;
                if(this.addCreditsValue){
                    this.title = LocService.t('label_add_credit_title')
                }else{
                    this.title = LocService.t('label_take_credit_title')
                }
            }
        },
        amount: function(val, oldVal) {
            this.hasError = '';
        },
    },


    methods: {
        close() {
            this.$topnavbar.$emit('closeAddCredit')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddCredit')
        },
        useCredits: useCredits,
        addCredit: addCredit,
        reset: reset,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--large'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        }
    }
}



function reset() {
   this.addCredits = 0;
   this.selectedUser = 0;
   this.amount = 0;
}



function addCredit(){
    if(!this.addCreditsValue) {
        this.useCredits()
        return;
    }
    let _self = this;
    const newModel = {
        amount: this.amount,
        userId:  this.selectedUser.id,
        creditType: this.addCredits ? 'PLUS': 'MINUS'
    };
    _self.isLoading = true;
    AdminApiService.addUserCredit(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.isLoading = false;
            _self.hasError = LocService.t('label_error') + ': ' + error.data.localized_error_message

        })
}

function useCredits(){
    let _self = this;
    const newModel = {
        creditToUse: this.amount,
        userId:  this.selectedUser.id,
    };
    _self.isLoading = true;
    AdminApiService.useUserCredit(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.isLoading = false;
            _self.hasError = LocService.t('label_error') + ': ' + error.data.localized_error_message
        })
}



// WEBPACK FOOTER //
// ./src/modals/AddUserCredit.js